// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid {
  grid-auto-columns: repeat(5, auto);
}
.grid.filters {
  grid-template-columns: repeat(5, auto);
}
`, "",{"version":3,"sources":["webpack://./src/app/property-module/properties/properties.component.less"],"names":[],"mappings":"AAEA;EACI,SAAA;AADJ;AAGA;EACI,kCAAA;AADJ;AAGA;EACI,sCAAA;AADJ","sourcesContent":["@import (reference) url(\"../../../styles.less\");\n\nh1 {\n    margin: 0;\n}\n.grid {\n    grid-auto-columns: repeat(5, auto);\n  }\n.grid.filters {\n    grid-template-columns: repeat(5, auto);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
